export default {
  setUser(state, payload) {
    state.data = payload;
  },
  setlogoUploadPercentage(state, payload) {
    state.logoUploadPercentage = payload.value;
  }
};
